import { Dialog, Box } from '@mui/material';
import styled from 'styled-components';
import { colors } from '../../theme';

import GlobalButton from '../global/button';
import CloseIcon from '@mui/icons-material/Close';

const AlertPopup = (props) => {
    const { open, setOpen, msg, leftOnClick, rightOnClick, isOneButton, buttonText } = props;

    return (
        <Dialog open={open} maxWidth="xs" fullWidth sx={{ borderRadius: '10px' }}>
            <Container>
                <Box
                    sx={{
                        justifyContent: 'flex-end',
                        p: '0px 30px',
                    }}
                >
                    <XButton
                        onClick={() => {
                            setOpen(false);
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        justifyContent: 'center',
                        m: '20px 30px 40px 30px',
                    }}
                >
                    {msg}
                </Box>
                {isOneButton ? (
                    <Box
                        sx={{
                            justifyContent: 'center',
                            borderTop: `1px solid ${colors.border}`,
                            p: '20px 30px 0px 30px',
                        }}
                    >
                        <GlobalButton variant="contained" text={buttonText} onClick={leftOnClick} />
                    </Box>
                ) : (
                    <Box
                        sx={{
                            justifyContent: 'space-between',
                            borderTop: `1px solid ${colors.border}`,
                            p: '20px 30px 0px 30px',
                        }}
                    >
                        <GlobalButton variant="outlined" text="Quit Without Saving" onClick={leftOnClick} />
                        <GlobalButton variant="contained" text="Save" onClick={rightOnClick} />
                    </Box>
                )}
            </Container>
        </Dialog>
    );
};

export default AlertPopup;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 0px;

    div {
        display: flex;
    }
`;

const XButton = styled(CloseIcon)`
    background: #f8f8f8;
    color: ${colors.blue.main};
    border-radius: 5px;
    cursor: pointer;
`;
